import http from '@/utils/http';
const base_path = '/v2/tool/deliveryContent';

/**
 * 获取投放内容接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getDeliveryContentApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 同步投放内容接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const pullDeliveryContentApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};

/**
 * 创建投放内容接口
 * @param {Object} data body请求数据
 * @returns {Promise<Object>}
 */
export const addDeliveryContentApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};
